import { create } from 'zustand';

export interface LabelSettingsState {
  line2Field: string | null; // field id or null for none
  setLine2Field: (fieldId: string | null) => void;
}

export const useLabelSettingsStore = create<LabelSettingsState>((set) => ({
  line2Field: null,
  setLine2Field: (fieldId) => set({ line2Field: fieldId }),
}));

export function setLine2FieldFromDiagramSettings(fieldId: string | null | undefined): void {
  useLabelSettingsStore.getState().setLine2Field(fieldId ?? null);
}
